module.exports = __webpack_public_path__ + "media/images/institutional3-b295cabd82ee2a86ad9ef5609f37795d.png";